import { createLucideIcon } from "lucide-react";

export const ChevronDownCircle = createLucideIcon(
    "ChevronDownCircle",
    [
        [
            "path",
            {
                d: "M8 10.5L11.7 13.275C11.8778 13.4083 12.1222 13.4083 12.3 13.275L16 10.5",
                key: "175mg6",
            },
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                key: "1mglay",
                r: "10",
            },
        ],
    ],
);
